import { lazy } from 'react'

// 懒加载所有 figma 相关的页面组件
const UserProfile = lazy(() => import('@/pages/figma/UserProfile'))
const FinanceAcademy = lazy(() => import('@/pages/figma/FinanceAcademy'))
const SignUp = lazy(() => import('@/pages/figma/SignUp'))
const ArticleDetail = lazy(() => import('@/pages/figma/ArticleDetail'))
const ECommerce = lazy(() => import('@/pages/figma/ECommerce'))
const ChaiyaoHome = lazy(() => import('@/pages/figma/ChaiyaoHome'))

// 定义所有 figma 相关的路由
const figmaRoutes = [
  {
    path: 'figma/user-profile',
    element: <UserProfile />,
    meta: { title: '用户资料卡片', icon: 'UserOutlined', permission: 'figma:user-profile:view' },
  },
  {
    path: 'figma/finance-academy',
    element: <FinanceAcademy />,
    meta: { title: '金融学院', icon: 'BankOutlined', permission: 'figma:finance-academy:view' },
  },
  {
    path: 'figma/signup',
    element: <SignUp />,
    meta: { title: '注册', icon: 'UserAddOutlined', permission: 'figma:signup:view' },
  },
  {
    path: 'figma/article/:id?',
    element: <ArticleDetail />,
    meta: { title: '文章详情', icon: 'FileTextOutlined', permission: 'figma:article:view' },
  },
  {
    path: 'figma/ecommerce',
    element: <ECommerce />,
    meta: { title: '电商仪表板', icon: 'ShoppingOutlined', permission: 'figma:ecommerce:view' },
  },
  {
    path: 'figma/chaiyao-home',
    element: <ChaiyaoHome />,
    meta: { title: '柴窑首页', icon: 'HomeOutlined', permission: 'figma:chaiyao-home:view' },
  },
]

export default figmaRoutes
